export default __webpack_public_path__ + "static/media/noPosterSmall.39a0a5e8.jpg";